{
  "checkedInTitle": "لقد سجّلت وصولك",
  "postCheckInInstructions": "تعليمات ما بعد تسجيل الوصول",
  "appointmentDetails": "تفاصيل الموعد",
  "notifyWarehouse": "أبلغنا المستودع بوصولك حتى يتمكنوا من التحقق من توفرهم",
  "waitForStaff": "يرجى انتظار مزيد من التعليمات من موظفي المستودع",
  "unplannedDescription": "يبدو أنه ليس لديك موعد. يرجى انتظار مزيد من التعليمات من موظفي المستودع.",
  "whatsappDelay": "قد تستغرق رسالة واتساب الأولى ما يصل إلى دقيقة واحدة للوصول.",
  "bookNextTitle": "احجز موعدًا للمرة القادمة",
  "bookNextBody": "سجّل في Opendock حتى تتمكن من حجز موعد في المرة القادمة التي تأتي فيها إلى هذه المنشأة",
  "helpFooter": "إذا كنت بحاجة إلى مساعدة أو معلومات إضافية، يرجى التواصل مع موظفي المستودع",
  "finalize": "إنهاء ({seconds})"
}
